import { isSimpleObject } from './is-simple-object';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const explodeObjectIntoQueryParams = (params: any, sourceKey = '', explodedParams: any = {}): any => {
  for (const key of Object.keys(params)) {
    if (isSimpleObject(params[key])) {
      explodeObjectIntoQueryParams(params[key], sourceKey ? `${sourceKey}.${key}` : key, explodedParams);
    } else {
      explodedParams[sourceKey ? `${sourceKey}.${key}` : key] = params[key];
    }
  }
  return explodedParams;
};
